var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import BannerAd from '../components/ibok-core/module/BannerAd';
import NotificationCard from '../components/ibok-core/module/NotificationCard';
import OauthProviderList from '../components/login/OauthProviderList';
import useAdsBannerForPage from '../hooks/useAdsBannerForPage';
import { BrowserAuthApiError, loginBrowserSession } from '../utils/api/browserAuthApi';
import { fetchOptionalLegacyProps } from '../utils/config';
import { getQueryParamByName } from '../utils/urlDecoder';
var defaultNavigate = function (href) {
    window.location.href = href;
};
var getLoginRedirect = function () {
    var redirect = getQueryParamByName('redirect');
    if (!redirect || !redirect.startsWith('/') || redirect.startsWith('//')) {
        return '/min_side';
    }
    return redirect;
};
var getLoginErrorMessage = function (error) {
    if (error instanceof BrowserAuthApiError) {
        return error.message;
    }
    return 'Kunne ikke opprette innloggingen. Prøv igjen.';
};
var LoginPage = function (_a) {
    var _b;
    var _c = _a.navigate, navigate = _c === void 0 ? defaultNavigate : _c;
    var banners = useAdsBannerForPage('login').banners;
    var _d = useState(null), loginError = _d[0], setLoginError = _d[1];
    var _e = useState(false), isSubmitting = _e[0], setIsSubmitting = _e[1];
    var initialEmail = getQueryParamByName('email') || '';
    var accountExists = getQueryParamByName('account_exists') === '1';
    var legacyNotification = (_b = fetchOptionalLegacyProps()) === null || _b === void 0 ? void 0 : _b.notification;
    var handleSubmit = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var form, formData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    form = event.currentTarget;
                    formData = new FormData(form);
                    setLoginError(null);
                    setIsSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, loginBrowserSession({
                            email: String(formData.get('email') || ''),
                            password: String(formData.get('password') || ''),
                            rememberMe: formData.has('keep_logged_in'),
                        })];
                case 2:
                    _a.sent();
                    navigate(getLoginRedirect());
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Failed to create browser auth session', error_1);
                    setLoginError(getLoginErrorMessage(error_1));
                    setIsSubmitting(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return React.createElement(React.Fragment, null,
        React.createElement("h1", null, "Logg inn"),
        React.createElement("p", null, "Logg inn med eksisterende bruker, eller gjennom Facebook, Google eller din universitetsbruker (Feide)"),
        React.createElement("div", null,
            React.createElement("div", { className: "horizontal" },
                React.createElement("section", null,
                    React.createElement("h2", null, "Gjennom iBok"),
                    accountExists && React.createElement(NotificationCard, { type: "info", title: "E-posten er allerede registrert" },
                        React.createElement("p", null, "Pr\u00F8v \u00E5 logge inn med passordet ditt. Hvis du ikke husker passordet, kan du bruke glemt passord-lenken under.")),
                    legacyNotification && React.createElement(NotificationCard, { type: "error", title: "Kunne ikke logge inn" },
                        React.createElement("p", null, legacyNotification)),
                    loginError && React.createElement(NotificationCard, { type: "error", title: "Kunne ikke logge inn" },
                        React.createElement("p", null, loginError)),
                    React.createElement("form", { action: "logg_inn", method: "post", className: "vertical", onSubmit: handleSubmit },
                        React.createElement("label", null,
                            "E-postadresse:",
                            React.createElement("input", { name: "email", type: "email", placeholder: "ola@nordmann.no", autoFocus: true, required: true, autoComplete: "email", defaultValue: initialEmail })),
                        React.createElement("label", null,
                            "Passord:",
                            React.createElement("input", { name: "password", type: "password", placeholder: "********", required: true, autoComplete: "current-password" })),
                        React.createElement("label", null,
                            React.createElement("input", { name: "keep_logged_in", type: "checkbox", defaultChecked: true }),
                            "Forbli innlogget"),
                        React.createElement("nav", { className: "columns" },
                            React.createElement("a", { href: "glemt_passord", className: "green-color" }, "Glemt passord"),
                            React.createElement("a", { href: "registrer", className: "green-color" }, "Registrer deg n\u00E5")),
                        React.createElement("button", { type: "submit", disabled: isSubmitting }, isSubmitting ? 'Logger inn...' : 'Logg inn'))),
                React.createElement("section", null,
                    React.createElement("h2", null, "Gjennom Tredjepartstjenester"),
                    React.createElement(OauthProviderList, null),
                    React.createElement("a", { href: "/hjelp/#oauth", className: "green-color" }, "Hva er dette?"),
                    React.createElement("p", null, "OBS! Dersom du har problemer med \u00E5 logge inn med tredjepartstjenester, pr\u00F8v \u00E5 logge inn gjennom iBok."))),
            React.createElement(BannerAd, { banners: banners, page: "login", size: "desktop" })));
};
export default LoginPage;
